import '@/styles/main.scss'

import * as components from './components'
import { createUntitled as _createUntitled } from './framework'
import type { UntitledOptions } from './framework'

export const createUntitled = (options: UntitledOptions = {}) => {
  return _createUntitled({ components, ...options })
}

export * from './composables'
export { components }
